export const locationFinder2023Gql = `... on landingPageContent2023_locationFinder_BlockType{
  typeHandle
   places {
      ... on excel_Asset {
        url
      }
   }
}`;
